// extracted by mini-css-extract-plugin
module.exports = {"collections_tab":"CollectionsTab_collections_tab__UXaY7","collections_list":"CollectionsTab_collections_list__1owBb"};